export const NOT_SET = Symbol("NOT_SET");

export const AUTH_STORE_NAME = "auth";
export const USER_ADMIN_ROUTE = "/user";
export const OFFICE_ADMIN_ROUTE = "/office";
export const PEOPLE_ANALYTICS_ROUTE = "/people-analytics/people";
export const OFFICE_EVENTS_ROUTE = "/office-events/list";
